import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PartnerAnalysisGroup3 extends BaseEntity{

    partnerAnalysisGroup3Code : string;
    name : string;
    rank : number;
    
}

